"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goNovelReader = void 0;
const novel_open_base_1 = require("@tencent/novel-open-base");
/**
 * 打开自适应的小说阅读器
 * @param {number|string} bookID 书籍id
 * @param {object} [params] 附带参数
 * @param {boolean} [isNeedTBS]
 * @returns {object} 表示跳转结果的对象（成功与否）
 */
exports.goNovelReader = (bookID, params, isNeedTBS = true) => {
    if (!bookID) {
        return { code: -1, message: 'goToNovelReader must have bookID' };
    }
    if (typeof bookID === 'string' && isNaN(parseInt(bookID, 10))) {
        return { code: -2, message: 'goToNovelReader bookID must be invalid' };
    }
    let url = '';
    const isLargerThan920 = novel_open_base_1.qb.getBuild() >= 92e3;
    if (isLargerThan920) {
        url = `qb://ext/novelreader?mode=normal&bookId=${bookID}`;
    }
    else {
        url = `https://bookshelf.html5.qq.com/autojump/read?bookid=${bookID}`;
    }
    novel_open_base_1.qb.openUrl(url, params, !!isNeedTBS);
    return { code: 0, message: 'OK' };
};
